import React from "react";
import { Link } from "react-router-dom";
import SEO from '../components/SEO';

const title = "About Us | AKHSoft";
const description = "Learn about AKHSoft — a purpose-driven software company dedicated to delivering custom software, websites, and digital marketing with integrity and innovation.";
const keywords = "About AKHSoft, software company Pakistan, custom software, ERP development, website design, digital solutions, software agency";const path = typeof window !== "undefined" ? window.location.pathname : "";

export default function AboutUs() {
  return (
    <>
   <SEO 
      title={title}
      description={description}
      keywords={keywords}
      path={path}
    />
    <div className="w-full">
      {/* Hero Section */}
      <div className="bg-[#0a3c6d] py-20 text-white text-center px-4">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">About AKHSoft</h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          We are a purpose-driven software development company — committed to delivering scalable digital solutions that empower businesses.
        </p>
      </div>

      {/* Tribute Section */}
      <div className="bg-white py-16 px-6 md:px-16 text-gray-800">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-semibold mb-4">A Legacy That Inspires</h2>
            <p className="text-lg mb-4">
              AKHSoft was founded in loving memory of our founder’s late father — a hardworking automotive technician whose values, honesty, and work ethic laid the invisible foundation for this dream.
            </p>
            <p className="text-lg mb-4">
              The name “AKH” isn’t just a brand — it's a tribute. Each project we deliver is fueled by the same dedication and sincerity he exemplified in his craft.
            </p>
            <p className="italic text-sm text-gray-600">✨ Inspired by a father. Driven by meaning. Built with honesty.</p>
          </div>
          <div className="text-center">
            <img
              src="/images/legacy.jpg"
              alt="AKH Legacy"
              className="rounded-2xl shadow-xl w-full max-w-md mx-auto"
            />
          </div>
        </div>
      </div>

      {/* Our Mission */}
      <div className="bg-[#f5f9ff] py-16 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-bold text-[#0a3c6d] mb-6">Our Mission</h2>
        <p className="text-lg max-w-3xl mx-auto text-gray-700">
          At AKHSoft, our mission is to empower businesses through custom-built digital solutions. Whether it’s a scalable web app, a smart business website, or a digital marketing campaign — we aim to deliver impact and value.
        </p>
      </div>

      {/* What We Do */}
    <div className="py-16 px-6 md:px-20 bg-white">
  <h2 className="text-3xl font-bold text-[#0a3c6d] text-center mb-12">
    What We Do
  </h2>
  <div className="grid gap-8 md:grid-cols-3 text-center">
    {/* Custom Software Development */}
    <div className="border-t-4 border-[#0a3c6d] p-6 shadow-md rounded-lg flex flex-col items-center">
      <div className="text-4xl mb-4">💻</div>
      <h3 className="text-xl font-semibold mb-2">Custom Software Development</h3>
      <p className="text-gray-700 mb-4">
        We build scalable, secure, and modern business software tailored to your requirements — from internal tools to ERP systems.
      </p>
      <Link
        to="/software-development/custom-software-development"
        className="mt-auto bg-[#0a3c6d] text-white px-5 py-2 rounded border border-[#0a3c6d] hover:bg-[#062949] transition font-semibold"
      >
        Read More
      </Link>
    </div>

    {/* Website Development */}
    <div className="border-t-4 border-[#ff9b00] p-6 shadow-md rounded-lg flex flex-col items-center">
      <div className="text-4xl mb-4">🌐</div>
      <h3 className="text-xl font-semibold mb-2">Website Design & Development</h3>
      <p className="text-gray-700 mb-4">
        From small business sites to full-service portals — our responsive websites deliver speed, SEO performance, and trust.
      </p>
      <Link
        to="/website-design"
        className="mt-auto bg-[#ff9b00] text-white px-5 py-2 rounded border border-[#ff9b00] hover:bg-[#e68e00] transition font-semibold"
      >
        Read More
      </Link>
    </div>

    {/* Digital Marketing */}
    <div className="border-t-4 border-[#8cc540] p-6 shadow-md rounded-lg flex flex-col items-center">
      <div className="text-4xl mb-4">📈</div>
      <h3 className="text-xl font-semibold mb-2">Digital Marketing</h3>
      <p className="text-gray-700 mb-4">
        We craft campaigns using SEO, PPC, and social strategies that grow your online presence and generate qualified leads.
      </p>
      <Link
        to="/digital-marketing"
        className="mt-auto bg-[#8cc540] text-white px-5 py-2 rounded border border-[#8cc540] hover:bg-[#6e9e33] transition font-semibold"
      >
        Read More
      </Link>
    </div>
  </div>
</div>


      {/* Our Clients */}
      <div className="bg-[#0a3c6d] text-white py-16 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-bold mb-6">Clients Who Trusted Us</h2>
        <p className="text-lg max-w-3xl mx-auto mb-8">
          We've proudly delivered solutions to real clients — including United Motors and other local businesses — through honest development and reliable service.
        </p>
        <div className="flex justify-center gap-6 flex-wrap">
          <img src="/images/clients/united-motors-logo.png" alt="United Motors" className="h-12 object-contain" />
          {/* Add more client logos as needed */}
        </div>
      </div>

      {/* Footer CTA */}
      <div className="bg-[#f5f9ff] text-center py-16 px-6 md:px-20">
        <h2 className="text-2xl font-bold text-[#0a3c6d] mb-4">
          Let’s Build Something Together
        </h2>
        <p className="text-lg max-w-2xl mx-auto text-gray-700 mb-6">
          Ready to turn your idea into a working product? We’re just a message away.
        </p>
        <a
          href="/contact-us"
          className="inline-block bg-[#0a3c6d] hover:bg-[#082b4c] text-white font-semibold px-6 py-3 rounded-full transition"
        >
          Contact Us
        </a>
      </div>
    </div>
    </>
  );
}
